import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  mainComponent: {
    "@media (min-width: 360px)": {
      background: "linear-gradient(90deg, #F9FAFB 0%, #F2F4F7 100%)",
      height: "100%",
      width: "100%",
      padding: "16px 32px",
      minHeight: "100vh",
      minWidth: "95vw",
    },
  },
  mapSection: {
    border: "1px solid #e4e7ed",
    borderRadius: "0 0 12px 12px",
    width: "100%",
    marginTop: 15,
    padding: "24px 8px",
    marginBottom: 40,
    "@media (min-width: 360px)": {
      width: "100%",
      backgroundColor: "#fff",
      marginTop: 10,
    },

    "@media (min-width: 1140px)": {
      padding: "24px",
    },
  },
}));

export default styles;
